module.exports = __webpack_public_path__ + "img/logo-el_alquimista-v1.f0580e20.svg";